/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Airflowpressureswitchdefect4Inputs */



/**
* | output |
* | --- |
* | "Airflow switch fault" |
*
* @param {Ahu_History_Key_Airflowpressureswitchdefect4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_airflowpressureswitchdefect4 = /** @type {((inputs?: Ahu_History_Key_Airflowpressureswitchdefect4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Airflowpressureswitchdefect4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Airflow switch fault")
	return /** @type {LocalizedString} */ ("Défaut débit")
});
export { ahu_history_key_airflowpressureswitchdefect4 as "ahu_history_key_airFlowPressureSwitchDefect" }